import MultiSelect from '../components/dumb/form/MultiSelect';
import DateSelector from '../components/dumb/form/DateSelector';

function ExportLeadForm({ courses, batches, params, leadStages, pipelineStages,
    onSelectCourse, onSelectBatch, onSelectParam, onSelectLeadStage,
    onSelectStartDate, onSelectEndDate, onSelectPipelineStage, onClick }) {
    return (
        <div style={{ marginTop: '20px' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%'}}>
                <div className="form-group">
                    <label> <b> Select Courses </b> </label>
                    <MultiSelect
                        options={courses}
                        value={course => course.courseName}
                        display={course => course.courseName}
                        onChange={onSelectCourse}
                    />
                </div>
                <div className="form-group">
                    <label style={{marginRight: '20px'}}> Select Batches </label>
                    <MultiSelect
                        options={batches}
                        value={batch => batch.batchName}
                        display={batch => `${batch.batchName}`}
                        onChange={onSelectBatch}
                    />
                </div>
                <div className="form-group">
                    <label style={{marginRight: '20px'}}> Data To Export </label>
                    <MultiSelect
                        options={params}
                        value={param => param}
                        display={param => param}
                        onChange={onSelectParam}
                    />
                </div>
                <div className="form-group">
                    <label style={{marginRight: '20px'}}> Lead Stages </label>
                    <MultiSelect
                        options={leadStages}
                        value={leadStage => leadStage}
                        display={leadStage => leadStage}
                        onChange={onSelectLeadStage}
                    />
                </div>
                {/* <div className="form-group">
                    <label style={{ marginRight: '20px'}}> <b> Pipeline Stage </b> </label>
                    <MultiSelect
                        options={pipelineStages}
                        value={pipelineStage => pipelineStage.key}
                        display={pipelineStage => pipelineStage.display}
                        onChange={onSelectPipelineStage}
                    />
                </div> */}
                <div className="form-group">
                    <label style={{marginRight: '20px'}}> Start Date </label>
                    <DateSelector selectDate={date => onSelectStartDate(date)} />
                </div>
                <div className="form-group">
                    <label style={{marginRight: '20px'}}> End Date </label>
                    <DateSelector selectDate={date => onSelectEndDate(date)} />
                </div>
            </div>
            <button
                onClick={() => onClick()}
                className="btn btn-primary"
            >
                Submit
            </button>
        </div>
    )
}

export default ExportLeadForm;